import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    // BooleanField,
    Filter,
    List,
    SearchInput,
    BooleanInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin';
const PcFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <BooleanInput
            source="is_published"
            label="resources.pcs.fields.is_published"
        />
        <ReferenceInput
            alwaysOn
            emptyText="resources.teams.all"
            label="resources.users.fieldGroups.team"
            source="teams"
            reference="teams"
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);
const PcList = (props: any) => {
    return (
        <List
            {...props}
            filters={<PcFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
        >
            <Datagrid optimized rowClick="edit">
                <TextField source="title" label="resources.pcs.fields.title" />
                {/* <BooleanField
                    source="is_published"
                    label="resources.pcs.fields.is_published"
                /> */}
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.pcs.fields.created_at"
                />
            </Datagrid>
        </List>
    );
};

export default PcList;
